import { FC } from 'react';
import { AppsUl, Copyright, FooterContainer, FooterContent, HomeLink } from './Footer.styles';

const Footer: FC = () => {
	const currentYear = new Date().getFullYear();

	return (
		<FooterContainer>
			<FooterContent>
				<Copyright>
					© Copyright {currentYear} <HomeLink to='/'>Canal do Repasse</HomeLink> Todos os direitos
					reservados
				</Copyright>
				<AppsUl>
					<li>
						<a
							href='https://play.google.com/store/apps/details?id=com.ionicframework.canaldorepasse196254&hl=pt-BR'
							target='_blank'
							rel='noreferrer'
						>
							<img src={`${process.env.PUBLIC_URL}/images/google-btn.png`} alt='Google Play' height={40} />
						</a>
					</li>
					<li>
						<a
							href='https://itunes.apple.com/us/app/canal-do-repasse/id1139042595?mt=8'
							target='_blank'
							rel='noreferrer'
						>
							<img src={`${process.env.PUBLIC_URL}/images/app-btn.png`} alt='App Store' height={40} />
						</a>
					</li>
				</AppsUl>
			</FooterContent>
		</FooterContainer>
	);
};

export default Footer;
